import { configureStore } from '@reduxjs/toolkit'
import userReducer from './userSlice'
import pageReducer from './pageSlice'
import colabReducer from './colabSlice'
import notificationSlice from './notificationSlice'
import actualizarComponete from './actualizar'
import ColaboradorSlice from 'Components/Colaboradores/redux/slice'
import PerfilesPuestoSlice from "#perfilesPuesto/redux/slice"
import VacanteSlice from '#vacantes/redux/slice'
import TrainingSlice from '#training/redux/slice'
import CandidateSlice from '#candidate/redux/slice'
import VacancySlice from '#vacancy/redux/slice'
import LoanSlice from '#loan/redux/slice'
import  reloadSlice  from './reload'


export default configureStore({
  reducer: {
    user: userReducer,
    page: pageReducer,
    colaborador: colabReducer,
    notification: notificationSlice,
    actualizar: actualizarComponete,
    colaboradorN:ColaboradorSlice,
    perfilesPuesto:PerfilesPuestoSlice,
    vacante:VacanteSlice.reducer,
    training:TrainingSlice.reducer,
    candidate:CandidateSlice.reducer,
    vacancy:VacancySlice.reducer,
    loan:LoanSlice.reducer,
    reload: reloadSlice.reducer
  },
})